import { render, staticRenderFns } from "./detailShare.vue?vue&type=template&id=08ab8ea4"
import script from "./detailShare.vue?vue&type=script&lang=js"
export * from "./detailShare.vue?vue&type=script&lang=js"
import style0 from "./detailShare.vue?vue&type=style&index=0&id=08ab8ea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports